import { render, staticRenderFns } from "./QuickProtocolCreateList.vue?vue&type=template&id=3f58d488&scoped=true"
import script from "./QuickProtocolCreateList.vue?vue&type=script&lang=js"
export * from "./QuickProtocolCreateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f58d488",
  null
  
)

export default component.exports